module.exports = __webpack_public_path__ + "img/video-train.4be6806b.png";